import React from 'react';
const { useCallback, useState, useMemo } = React;
import { useDropzone } from 'react-dropzone';

import {
	Root,
	ContentLayout,
	DropzoneItemsLayout,
	DropzoneItem,
} from './styled';


export type FileDropzoneProps = {
	value?: Array<File>;
	accept?: string | string[];
	maxSize?: number;
	limit?: number;
	disabled?: boolean;
	renderLabel?: () => React.ReactNode;
	renderDragActiveContent?: () =>  React.ReactNode;
	onChange?: (files: Array<File>) => void;
}

const FileDropzone: React.SFC<FileDropzoneProps> = (props) => {
	const {
		value,
		renderLabel,
		renderDragActiveContent,
		accept,
		maxSize,
		limit,
		disabled,
		onChange,
		...rest
	} = props;
	const [acceptedFiles, setAcceptedFiles] = useState<Array<File>>(value);
  const onDrop = useCallback(files => {
		setAcceptedFiles([...acceptedFiles, ...files]);
		typeof onChange === 'function' && onChange([...acceptedFiles, ...files]);
  }, [acceptedFiles]);
	const { getRootProps, getInputProps, isDragActive } = useDropzone({
		onDrop,
		accept,
		maxSize,
		disabled: acceptedFiles.length >= limit || disabled,
	});

	const renderAcceptedFiles = useMemo(() => () => {
		return (
			<DropzoneItemsLayout>
				{acceptedFiles.map((file, idx) => {
					return (
						<DropzoneItem key={idx}>{file.name}</DropzoneItem>
					);
				})}
			</DropzoneItemsLayout>
		);
	}, [acceptedFiles]);

  return (
    <Root {...getRootProps()} {...rest}>
      <input {...getInputProps()} />
			<ContentLayout>
				{
					acceptedFiles.length > 0
						?	renderAcceptedFiles()
						: isDragActive
							? renderLabel()
							: renderDragActiveContent()
				}
			</ContentLayout>
    </Root>
  )
}

FileDropzone.displayName = 'FileDropzone';
FileDropzone.defaultProps = {
	value: [],
	limit: Infinity,
	renderLabel: () => <p>Отпустите файл</p>,
	renderDragActiveContent: () => <p>Приложить файл</p>
};

export default FileDropzone;
